import request from '@/utils/request'

export function getList(data) {
    return request({
        url: 'admin/sys/usermessage/list',
        method: 'POST',
        data: data
    })
}

export function listGrounpByType() {
    return request({
        url: 'admin/sys/usermessage/listGrounpByType',
        method: 'POST'
    })
}

// 查询当前登录用户 消息列表
export function getUserMessage(data) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_URL,
        url: 'app/data/usermessage/list',
        method: 'POST',
        data: data
    })
}

// 修改消息为已读
export function updateReadMessage(data) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_URL,
        url: 'app/data/usermessage/update',
        method: 'POST',
        data: data
    })
}

/**
 * @returns 用户未读消息数量，最新消息内容
 */
export function getCountNotReadAndNewMsg(data) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_URL,
        url: 'app/data/usermessage/countNotReadAndNewMsg',
        method: 'POST',
        data: data
    })
}

/**
 * @returns 最新消息内容
 */
export function queryNewest(data) {
    return request({
        url: 'admin/sys/usermessage/queryNewest',
        method: 'POST',
        data: data
    })
}

/**
 * @returns 统计用户未读消息
 */
export function readFlagCount(data) {
    return request({
        url: 'admin/sys/usermessage/readFlagCount',
        method: 'POST',
        data: data
    })
}
export function getEnterpriseInletDataCount(data) {
    return request({
        url: 'admin/data/safetywarningremind/getEnterpriseInletDataCount',
        method: 'POST',
        data: data
    })
}
export function promptMonthly(companyId) {
    return request({
      url: `admin/sys/usermessage/promptMonthly/${companyId}`,
      method: 'get'
    })
  }
export function checkPrompt(companyId) {
    return request({
      url: `admin/sys/usermessage/checkPrompt/${companyId}`,
      method: 'get'
    })
  }